import { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext(null)

// Use the same base URL as Angular
const API_BASE_URL = '/api'

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined)
  const [loading, setLoading] = useState(true)

  // On mount, check localStorage for existing user (matches Angular constructor)
  useEffect(() => {
    const userx = localStorage.getItem('user')
    if (userx) {
      try {
        const parsed = JSON.parse(userx)
        setUser(parsed)
        console.log('User loaded from localStorage:', parsed)
      } catch (e) {
        setUser(null)
        localStorage.removeItem('user')
      }
    } else {
      setUser(null)
    }
    setLoading(false)
  }, [])

  // Login function - matches Angular userService.loginUser() exactly
  const login = async (username, password) => {
    console.log('Login attempt for:', username)

    try {
      // Match Angular's request exactly - simple fetch with minimal headers
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      })

      console.log('Response status:', response.status)

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        console.log('Login failed:', errorData)
        return {
          success: false,
          error: errorData.message || `Login failed (${response.status})`
        }
      }

      const data = await response.json()
      console.log('Login response data:', data)

      if (data) {
        // Store user in localStorage - matches Angular
        localStorage.setItem('user', JSON.stringify(data))
        setUser(data)
        return { success: true }
      } else {
        return { success: false, error: 'No user data returned' }
      }
    } catch (error) {
      console.error('Login error:', error)
      return { success: false, error: error.message || 'Network error' }
    }
  }

  // Logout function - matches Angular userService.logoutUser()
  const logout = () => {
    setUser(null)
    localStorage.removeItem('user')
    console.log('user logged out')
  }

  // Check if user is authenticated
  const isAuthenticated = !!user

  // Check if user is admin (has access_to_users permission)
  const isAdmin = user?.access_to_users === true || user?.access_to_users === 1

  const value = {
    user,
    loading,
    isAuthenticated,
    isAdmin,
    login,
    logout
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}